import React, { Component }  from 'react'
import { connect } from 'react-redux'
import CommonTable from 'components/Table'

import { Column } from 'react-virtualized'
import Badge from 'components/Badge'
import TaskStatusIcon from './StatusIcon'
import Numeral from 'numeral'
import calcTable from 'utils/calcTable'
import { tasksTable } from 'selectors/tasks'

import * as R from 'ramda'

let select = (state, props) => ({
	tasks: props.data!=undefined ? props.data : tasksTable(state)
})

export class TaskTable extends Component{
	render(){
		let { props } = this
		let cols = {
			status:60
  		  , task:{min:310, avg:720}
		  , project: {min:310, avg:350}
		  , property: {min:210, avg:250}
		  , manager:75
		  , type: 75
		  , attachComment:70
		}
		cols = calcTable(props.width || (window.innerWidth-60), cols)
		return(
			<CommonTable entity="task" showAll={props.showAll} data={props.tasks}>
				{cols.status &&
					<Column
						width={cols.status}
						label="status"
						dataKey="status"
						cellRenderer={
							({ rowData }) => (<TaskStatusIcon status={rowData.status} />)
						}
					/>
				}
				{cols.task &&
					<Column
						width={cols.task}
						label='task'
						dataKey='taskContent'
					/>
				}
				{cols.project &&
					<Column
						width={cols.project}
						label='project'
						dataKey='project'
					/>
				}
				{cols.property &&
					<Column
						width={cols.property}
						label='property'
						dataKey='property'
					/>
				}
				{cols.type &&
					<Column
						width={cols.type}
						label='type'
						dataKey='taskType'
					/>
				}
				{cols.manager &&
					<Column
						width={cols.manager}
						label='manager'
						dataKey='manager'
					/>
				}
				{cols.attachComment &&
					<Column
						width={cols.attachComment/2}
						label={<i style={{fontSize:"22px"}} className="material-icons">attach_file</i>}
						dataKey='attachments'
						disableSort
						cellRenderer={({ rowData }) =>
							<Badge
								style={{position:"relative", top:"8px", left:"-8px"}}
								badgeContent={rowData.attachments ? rowData.attachments.length : "0"}
								primary={false}
								secondary={rowData.attachments ? !!rowData.attachments.length : false}
							/>
						}
					/>
				}
				{cols.attachComment &&
					<Column
						width={cols.attachComment/2}
						label={<i style={{fontSize:"22px"}} className="material-icons">comment</i>}
						dataKey='comments'
						disableSort
						cellRenderer={({ rowData }) =>
							<Badge
								style={{position:"relative", top:"8px", left:"-8px"}}
								badgeContent={rowData.comments ? rowData.comments.length : "0"}
								primary={false}
								secondary={rowData.comments ? !!rowData.comments.length : false}
							/>
						}
					/>
				}
			</CommonTable>
		)
	}
}
export default connect(select)(TaskTable)



// WEBPACK FOOTER //
// ./src/routes/manager/tasks/Table.js